<template>
  <div class="TInfoWhatIsLifferyNew">
    <m-header-seo>
      <o-for-people-hero-section v-on:scroll-next="handleScrollNext" id="hero-section"/>
    </m-header-seo>

    <o-why-are-why-doing-this/>

    <o-how-people-use-liffery/>

    <o-our-mission/>

  </div>
</template>

<style lang="scss">
.deDe {
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

.TInfoWhatIsLifferyNew {
  background-color: $landingPageCream;
  color: $black;

  .button.is-outlined.is-primary:not(.is-loading) {
    background-color: unset !important;
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { UserPlusIcon } from 'vue-feather-icons';
import { translation } from '@/plugins/i18n/Translation';
import SeoInjector from '@/services/SeoInjector';
import { RouteNames } from '@/router/RouteNames';
import OAreYouABusiness from '@/components/organisms/landing/sections/OAreYouABusiness.vue';
import OConnectPeople from '@/components/organisms/landing/sections/OConnectPeople.vue';
import OCaptureAndConsider from '@/components/organisms/landing/sections/OCaptureAndConsider.vue';
import OForPeopleHeroSection from '@/components/organisms/landing/sections/OForPeopleHeroSection.vue';
import MHeaderSeo from '@/components/molecules/landing/MHeaderSeo.vue';
import OLegend from '@/components/organisms/landing/sections/OLegend.vue';
import AScrollDownArrow from '@/storybook-components/src/stories/atoms/AScrollDownArrow.vue';
import OForPeopleFeatures from '@/components/organisms/landing/sections/OForPeopleFeatures.vue';
import { AuthenticationStore } from '@/store';
import isApp from '@/utils/isApp';
import isIosApp from '@/utils/isIosApp';
import EventBus, { EventBusEvents } from '@/EventBus';
import OHowPeopleUseLiffery from '@/components/organisms/landing/sections/OHowPeopleUseLiffery.vue';
import OWhyAreWhyDoingThis from '@/components/organisms/landing/sections/OWhyAreWhyDoingThis.vue';
import OOurMission from '@/components/organisms/landing/sections/OOurMission.vue';
import MComingSoonBanner from '@/components/molecules/landing/MComingSoonBanner.vue';

@Component({
  components: {
    MComingSoonBanner,
    OOurMission,
    OWhyAreWhyDoingThis,
    OHowPeopleUseLiffery,
    OForPeopleFeatures,
    AScrollDownArrow,
    OLegend,
    MHeaderSeo,
    OForPeopleHeroSection,
    OCaptureAndConsider,
    OConnectPeople,
    OAreYouABusiness,
    UserPlusIcon
  }
})
export default class TWhatIsLiffery extends Vue {
  links = {
    forBusiness: RouteNames.ROUTE_INFO_BUSINESS,
    contact: RouteNames.ROUTE_INFO_CONTACT
  };
  loginPromptLaunchedInApp = false;

  get currentLanguage () {
    return translation.currentLanguage;
  }

  mounted () {
    SeoInjector.init(this.$route);
    this.launchLoginPromptInApp();
  }

  // when loading this page in the app, automatically launch the login/signup prompt
  launchLoginPromptInApp () {
    if (!AuthenticationStore.authenticated && !this.loginPromptLaunchedInApp && (isApp() || isIosApp())) {
      this.loginPromptLaunchedInApp = true;
      EventBus.$emit(EventBusEvents.AUTH_LOGIN_CLICKED);
    }
  }

  handleScrollNext () {
    const el = document.getElementById('why-are-we-doing-this') as HTMLElement;
    el.scrollIntoView({
      behavior: 'smooth'
    });
  }
}
</script>
